<template>
    <form>
      <v-alert v-if="classcodeError" :value="true" type="error">
        {{ classcodeError }}
      </v-alert>
  
          <v-text-field
            @input="classcodeError=null"
            class="jumbo-input"
            height="100"
            v-model="classcode"
            v-validate="'required'"
            :error-messages="errors.collect('classcode')"
            :label="$t('navbar.signup.form.enter_code_from_teacher')"
            outlined
            data-vv-name="classcode"
            required
          />
          <div class="text-right">
            <v-btn
              depressed color="primary"
              @click="submitJoinClass"
            >
              {{ $t('actions.submit') }}
            </v-btn>
          </div>
    </form>
  </template>
  
  <script>
  export default {
    inject: ['$validator'],
    props: {
      joinClass: {
        type: [Boolean],
        required: false,
        default: true
      }
    },
    data: () => ({
      classcode: '',
      classcodeError: ''
    }),
    methods: {
      submitJoinClass() {
        if (this.joinClass && this.$auth.loggedIn) {
          this.connectClassroom(this.classcode)
        } else {
          this.classcodeExists()
        }
      },
      async classcodeExists() {
        try {
          const res = await this.$api.getClassbyClasscode(this.classcode)
          if (res.success) {
            this.$emit('next-step', this.classcode)
            this.classcodeError = ''
          } else {
            this.classcodeError = this.$t(
              'navbar.signup.form.errors.' + res.error
            )
          }
        } catch (e) {
          const data = e.response.data
          Object.keys(data).map(k => (this.classcodeError = data[k]))
        }
      },
      async connectClassroom(classcode) {
        try {
          const classdata = {
            classcode: classcode
          }
          const res = await this.$api.setClassbyClasscode(classdata)
          if (res.data.success == true) {
            this.$emit('joined-classroom', res.data.classroom)
              this.$store.commit('SET_STUDENT_SELECT_CLASS', res.data.classroom)
              this.$router.push(this.localePath('/') )
          } else {
            this.$emit('error', res.data.error)
            this.classcodeError = this.$t(
              'navbar.signup.form.errors.' + res.data.error
            )
          }
        } catch (e) {
          const data = e.response.data
          Object.keys(data).map(k => (this.classcodeError = data[k]))
        }
      }
    }
  }
  </script>
  
  <style>
  .jumbo-input input {
    font-size: 51px !important;
    font-weight: 900;
    height: 100px;
    padding: 0 20px;
    letter-spacing: 0.107em;
    max-height: 100px;
  }
  </style>